import React from 'react'

import { Loader } from '@pb/components'
import { Redirect } from 'react-router-dom'

const ConditionalRedirecter: React.FC<any> = ({
  shouldRedirect,
  shouldShowLoader,
  fallbackRoute,
  redirectState,
  children,
}) => {
  const redirectLoader = shouldShowLoader ? <Loader /> : null

  // This needs to come first as redirectLoader might be true even if we should redirect
  if (shouldRedirect) {
    return (
      <Redirect
        to={{
          pathname: fallbackRoute,
          state: redirectState,
        }}
      />
    )
  }

  if (redirectLoader) {
    return redirectLoader
  }

  return children
}

export default ConditionalRedirecter
